import { render, staticRenderFns } from "./bill-wp-revision.vue?vue&type=template&id=a81c96b4&"
import script from "./bill-wp-revision.vue?vue&type=script&lang=js&"
export * from "./bill-wp-revision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports